import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import moment from "moment";
import $ from "jquery";

const UpdateVehicleUtilities = ({
  selectedRowsData,
  updateHandleChange,
  getData,
  setRowAddData,
  rowAddData,
  setSelectedRowsData
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [selectedVehicleId, setSelectedVehicleId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedStafflId, setSelectedStaffId] = useState("");
  const [vehicle, setVehicle] = useState([]);
  const [Staff, setStaff] = useState([]);
  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };
  function resetFileds() {
    setRowAddData({
      battery_num: "",
      battery_brand: "",
      specification: "",
      warrenty_guarantee: "",
      purchase_date: "",
    });
    setSelectedStaffId("");
    setSelectedVehicleId("");
    setSelectedCompanyId("");
    setSelectedRowsData("");
  }
  const handleUpdateData = async (e) => {
    e.preventDefault();
    const {
      id,
      utility_type,
      utility_name,
      service_count,
      utility_usage,
      service_need,
      vehicle_part_breakdown,
      expense_of_breakdown,
      assembling_date,
    } = selectedRowsData;
    let BASE_URL =
      SERVER_URL +
      `/api/vehicle-utilities/vehicle-utilities-details/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        vehicle_id: selectedVehicleId,
        utility_type,
        utility_name,
        service_count,
        utility_usage,
        service_need,
        vehicle_part_breakdown,
        expense_of_breakdown,
        assembling_date: moment(assembling_date).format("YYYY-MM-DD"),
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setCompany(result.data);
  };

  useEffect(() => {
    if(selectedRowsData){
      getCompany();
    }
  }, [selectedRowsData]);

  useEffect(() => {
    if (selectedRowsData) {
      setSelectedCompanyId(selectedRowsData?.company_id);
      setSelectedStaffId(selectedRowsData?.driver_id);
      setSelectedVehicleId(selectedRowsData?.vehicle_id);
    }
  }, [selectedRowsData]);

  const handleVehicleChange = (e) => {
    setSelectedVehicleId(e.target.value);
  };

  const handleStaffChange = (e) => {
    setSelectedStaffId(e.target.value);
  };

  const handleCompanyChange = (e) => {
    const value = e.target.value;
    setSelectedCompanyId(value ? value : "");
    setStaff("");
  };

  const getStaff = async (e) => {
    const BASE_URL =
      SERVER_URL +
      `/api/staff-detials/drop-staffDetails/${user_id}?company_id=${selectedCompanyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStaff(result.data);
    } else {
      setStaff([]);
    }
  };
  useEffect(() => {
    if (selectedCompanyId) {
      getStaff();
    }
  }, [selectedCompanyId]);

  const getVehicle = async () => {
    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setVehicle(result.data);
  };
  useEffect(() => {
    if(selectedRowsData){
      getVehicle();
    }
  }, [selectedRowsData]);
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="editModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Vehicle Utilities
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form className="form-sample" onSubmit={handleUpdateData}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company_name">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={(e) => getStaff(e)}
                              value={selectedCompanyId}
                              id="company_name"
                              required
                            >
                              <option value="">Select Company Name</option>
                              {Company &&
                                Company?.length > 0 &&
                                Company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div> */}
                        {/* <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="staff_id">Driver Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleStaffChange}
                              value={selectedStafflId}
                              id="staff_id"
                              required
                            >
                              <option value="">Select Driver Name</option>
                              {Staff &&
                                Staff?.length > 0 &&
                                Staff?.map((item, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <option
                                        value={item.id}
                                      >{`${item.staff_name}`}</option>
                                    </React.Fragment>
                                  );
                                })}
                            </select>
                          </div>
                        </div> */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="material_name">
                              Vehicle Number
                            </label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleVehicleChange}
                              value={selectedVehicleId}
                              id="material_name"
                              required
                            >
                              <option value="">Select Vehicle</option>
                              {vehicle &&
                                vehicle?.length > 0 &&
                                vehicle?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.vehicle_number}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="utility_name">Utility Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="utility_name"
                              id="utility_name"
                              placeholder="Utility Name"
                              onChange={updateHandleChange}
                              value={selectedRowsData.utility_name}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="utility_type">Utility Type</label>
                            <input
                              type="text"
                              className="form-control"
                              name="utility_type"
                              id="utility_type"
                              placeholder="utility_type"
                              onChange={updateHandleChange}
                              value={selectedRowsData.utility_type}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="assembling_date">
                              Assembling Date
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="assembling_date"
                              id="assembling_date"
                              placeholder="Assembling Date"
                              onChange={updateHandleChange}
                              value={selectedRowsData.assembling_date}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="warrenty_guarantee">
                              Service Count
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="service_count"
                              id="service_count"
                              placeholder="Service Count"
                              onChange={updateHandleChange}
                              value={selectedRowsData.service_count}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="warrenty_guarantee">
                              Utility Usage
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="utility_usage"
                              id="utility_usage"
                              placeholder="Utility Usage"
                              onChange={updateHandleChange}
                              value={selectedRowsData.utility_usage}
                              // required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="service_need">Service Need</label>
                            <input
                              type="text"
                              className="form-control"
                              name="service_need"
                              id="service_need"
                              placeholder="Service Need"
                              onChange={updateHandleChange}
                              value={selectedRowsData.service_need}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="vehicle_part_breakdown">
                              Vehicle Part Breakdown
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="vehicle_part_breakdown"
                              id="vehicle_part_breakdown"
                              placeholder="Vehicle Part Breakdown"
                              onChange={updateHandleChange}
                              value={selectedRowsData.vehicle_part_breakdown}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="expense_of_breakdown">
                              Expense Of Breakdown
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="expense_of_breakdown"
                              id="expense_of_breakdown"
                              placeholder="Expense Of Breakdown"
                              onChange={updateHandleChange}
                              value={selectedRowsData.expense_of_breakdown}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateVehicleUtilities;
